module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Light.0b62b41.woff";